import { useAuthUser } from '~/hooks/useAuthUser'
import { useCanInstallSplitsConnect } from '~/hooks/useCanInstallSplitsConnect'
import { useIsGettingStarted } from '~/hooks/useIsGettingStarted'
import { useIsSplitsConnectInstalled } from '~/hooks/useIsSplitsConnectInstalled'
import { useSmartAccounts } from '~/hooks/useSmartAccounts'

export const useShowExtensionsNotification = () => {
  const { user } = useAuthUser()
  const { smartAccounts } = useSmartAccounts()
  const isInstalledHere = useIsSplitsConnectInstalled()
  const canInstallHere = useCanInstallSplitsConnect()
  const { isGettingStarted, isSettled: isGettingStartedSettled } =
    useIsGettingStarted()
  return (
    !isInstalledHere &&
    !user?.splitsConnectDetectedAt &&
    !user?.extensionsPageViewedAt &&
    canInstallHere &&
    smartAccounts.length > 0 &&
    isGettingStartedSettled &&
    !isGettingStarted
  )
}
